import { Outlet, Navigate } from "react-router-dom";
import BroadcastAnnouncements from "../components/broadcast/BroadcastAnnouncements";

export const userObj = JSON.parse(localStorage.getItem('user'));
const PrivateRoutes = () => {
    // let isAuthenticated = {'token':false}
    return(
        userObj?.token ? <><Outlet/><BroadcastAnnouncements key={userObj.token} token={userObj.token}/></> : <Navigate to='/login'/>
    )
}

export default PrivateRoutes;
